import { render } from "./InformationInfoBlock.vue?vue&type=template&id=2b9b89f8&scoped=true&ts=true"
import script from "./InformationInfoBlock.vue?vue&type=script&lang=ts"
export * from "./InformationInfoBlock.vue?vue&type=script&lang=ts"

import "./InformationInfoBlock.vue?vue&type=style&index=0&id=2b9b89f8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9b89f8"]])

export default __exports__